import {useTranslation} from "react-i18next";
import React from "react";

const InputCheckbox = ({label, description, id, errors, warning, defaultChecked = false, input}) => {

    const { t } = useTranslation();

    return (
        <div className="relative flex items-start">
            <div className="flex items-center h-5">
                <input
                    id={id}
                    aria-describedby={id+"-description"}
                    name={id}
                    defaultChecked={defaultChecked}
                    type="checkbox"
                    className="focus:ring-red-700 h-4 w-4 text-red-600 border-gray-300 rounded"
                    {...input}
                />
            </div>
            <div className="ml-3 text-sm">
                <label htmlFor={id} className="font-medium text-gray-700">
                    {label}
                </label>
                <p id={id+"-description"} className="text-gray-500">
                    {description}
                </p>
                {errors && errors.type === 'required' && (  <p className="mt-2 text-sm text-red-600">{warning ? warning : t("app.warning.description", {field: label.toLowerCase()})}</p>)}
            </div>
        </div>
    )
};
export default InputCheckbox;
